var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconListening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.70167 0 0 4.66632 0 10.4211V18.5263C0 20.4484 1.56333 22 3.5 22H7V12.7368H2.33333V10.4211C2.33333 5.94 5.985 2.31579 10.5 2.31579C15.015 2.31579 18.6667 5.94 18.6667 10.4211V12.7368H14V22H17.5C19.4367 22 21 20.4484 21 18.5263V10.4211C21 4.66632 16.2983 0 10.5 0Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListening);
export default __webpack_public_path__ + "static/media/icon_listening.53c3ab979479ea70b2f0d614981e85f8.svg";
export { ForwardRef as ReactComponent };